"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.CONTENT = exports.THEMES = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Beach = _interopRequireDefault(require("./Themes/Beach/Beach"));

var _NotFound = _interopRequireDefault(require("./Content/NotFound"));

var _Error = _interopRequireDefault(require("./Content/Error"));

require("./Stopper.scss");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* THEMES */

/* CONTENT */
var THEMES = {
  BEACH: 'beach'
};
exports.THEMES = THEMES;
var CONTENT = {
  NOT_FOUND: 'NotFound',
  ERROR: 'Error'
};
exports.CONTENT = CONTENT;

var themeLoader = function themeLoader(theme) {
  switch (theme) {
    case CONTENT.ERROR:
    default:
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Beach["default"], {});
  }
};

var contentLoader = function contentLoader(content) {
  switch (content) {
    case CONTENT.ERROR:
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Error["default"], {});

    default:
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_NotFound["default"], {});
  }
};
/* iF CHILDREN IS DEFINED WE IGNORE CONTENT */


var Stopper = function Stopper(_ref) {
  var children = _ref.children,
      theme = _ref.theme,
      content = _ref.content;
  var finalContent = children ? null : content;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "Stopper ".concat(content),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "childrenContainer",
      children: [children && children, !children && finalContent && contentLoader(finalContent)]
    }), themeLoader(theme)]
  });
};

Stopper.propTypes = {
  /**
   * {
   *  "info": "Establece los elementos que forman el componente",
   *  "kind": "both",
   *  "beautifulName": "Elememtos del componente"
   * }
   */
  children: _propTypes["default"].node,

  /**
   * {
   *  "info": "Establece el contenido del componente",
   *  "kind": "both",
   *  "beautifulName": "Elememtos del componente"
   * }
   */
  content: _propTypes["default"].string,

  /**
   * {
   *  "info": "Define el tema del componente en el array THEMES",
   *  "kind": "both",
   *  "beautifulName": "Elememtos del componente"
   * }
   */
  theme: _propTypes["default"].oneOf([THEMES.BEACH])
};
Stopper.defaultProps = {
  children: null,
  theme: THEMES.BEACH,
  content: CONTENT.NOT_FOUND
};
var _default = Stopper;
exports["default"] = _default;

//# sourceMappingURL=index.js.map